import { saveEventOnAnalytics } from '../../../../../../utils/helpers'

class CteList {
    static get $inject() {
        return ['gql', '$scope', '$uibModal', 'downloadService']
    }

    constructor(gql, scope, modal, downloadService) {
        this.gql = gql
        this.scope = scope
        this.modal = modal
        this.downloadService = downloadService

        this.apply = (fn) => scope.$apply(fn)

        this.order = { sortField: 'EMISSAO', sortOrder: 'DESC' }
        this.filter = {}
        this.perPage = 25

        this.ctes = []
        this.limiteXmlZip = 5000
        this.limiteDaZip = 100
    }

    $onChanges({ filter }) {
        if (filter) {
            if (filter.currentValue) {
                this.currentPage = 1
                this.filter = filter.currentValue
                this.loadingPromise = this.loadCtes()
            } else {
                this.ctes = null
            }
        }
    }

    sortBy(field) {
        let { sortField, sortOrder } = this.order

        if (field === sortField) {
            sortOrder = sortOrder === 'DESC' ? 'ASC' : 'DESC'
        } else {
            sortField = field
            sortOrder = 'ASC'
        }

        this.order = { sortField, sortOrder }
        this.loadingPromise = this.loadCtes()
    }

    getSortingClass(field) {
        let { sortField, sortOrder } = this.order

        if (field !== sortField)
            return 'fa-unsorted'
        else
            return `fa-sort-${sortOrder.toLowerCase()}`
    }

    pageChange(page) {
        this.loadingPromise = this.loadCtes(page)
    }

    async downloadXlsx() {
        const query = gql`
            query DownloadCtesXlsx($empresaId: Int!, $filter: CteFilter!) {
                contrato: empresa(id: $empresaId) {
                    id
                    ctesXlsx(filter: $filter) {
                        token
                    }
                }
            }
        `

        const promise = this.gql.query(query, { empresaId: this.contratoId, filter: this.filter })
        const { contrato: { ctesXlsx: { token } } } = await promise

        this.downloadPromise = this.downloadService.download(`/resume-operation/${token}`)
    }

    downloadXmlZip() {
        saveEventOnAnalytics('Operações com XML', 'Download CT-e XML ZIP', `Empresa: ${this.contratoId}`)

        this.paginatedDownloadOperation(this.buildOperationQuery('DownloadCtesXmlZip', 'ctesXmlZip', this.limiteXmlZip))
    }

    downloadDaZip() {
        saveEventOnAnalytics('Operações com XML', 'Download CT-e DACTE ZIP', `Empresa: ${this.contratoId}`)

        this.paginatedDownloadOperation(this.buildOperationQuery('DownloadCtesDaZip', 'ctesDaZip', this.limiteDaZip))
    }

    rateioFrete(cte) {
        this.modal.open({
            backdrop: 'static',
            component: 'nfeRateioFreteModal',
            size: 'lg',
            resolve: {
                cte: () => cte
            }
        })
    }

    downloadXml(cte) {
        saveEventOnAnalytics('Operações com XML', 'Download CT-e XML', `Empresa: ${this.contratoId}`)

        this.downloadOperation(this.fetchTokenCte('DownloadCteXml', cte.chave, 'xml'))
    }

    downloadDa(cte) {
        saveEventOnAnalytics('Operações com XML', 'Download CT-e DACTE', `Empresa: ${this.contratoId}`)

        this.downloadOperation(this.fetchTokenCte('DownloadCteDa', cte.chave, 'dacte'))
    }

    paginatedDownloadOperation(query, filter = null, order = null, nextPage = null, yesForAll = false) {
        if (!filter)
            filter = this.filter

        if (!order)
            order = this.order

        this.downloadPromise = this.gql
            .query(query, { empresaId: this.contratoId, next: nextPage, filter, order })
            .then(({ contrato: { operation } }) => operation)
            .then(({ token, next }) => {
                return this.downloadService
                    .download(`/resume-operation/${token}`)
                    .then(() => {
                        if (next) {
                            if (yesForAll)
                                this.paginatedDownloadOperation(query, filter, order, next, true)
                            else {
                                let options = {
                                    "Sim": () => this.paginatedDownloadOperation(query, filter, order, next),
                                    "Não": angular.noop
                                }

                                if ((filter.emissaoInicial && filter.emissaoFinal) || filter.participante) {
                                    options = {
                                        "Sim para todos": () => this.paginatedDownloadOperation(query, filter, order, next, true),
                                        ...options
                                    }
                                }

                                Confirm.info(
                                    "Download parcial",
                                    "Devido ao limite da operação solicitada, " +
                                    "não foi possível incluir todos os resultados. " +
                                    "Deseja realizar o download do próximo lote?",
                                    options
                                )
                            }
                        }
                    })
            })
    }

    buildOperationQuery(operation, type, limit) {
        return gql`
            query ${operation}($empresaId: Int!, $filter: CteFilter!, $order: CteOrder!, $next: String) {
                contrato: empresa(id: $empresaId) {
                    id
                    operation: ${type}(filter: $filter, order: $order, next: $next, limit: ${limit}) {
                        token
                        next
                    }
                }
            }
        `
    }

    downloadOperation(tokenPromise) {
        tokenPromise
            .then(token => this.downloadService.download(`/resume-operation/${token}`))
            .catch(console.error)
    }

    async fetchTokenCte(operation, chave, format) {
        const query = gql`
            query ${operation}($empresaId: Int!, $filter: CteFilter!) {
                contrato: empresa(id: $empresaId) {
                    id
                    ctesPage(filter: $filter) {
                        ctes: entries {
                            ... on Cte {
                                ${format} { token }
                            }
                        }
                    }
                }
            }
        `

        let { contrato: { ctesPage: { ctes: [cte] } } } =
            await this.gql.query(query, { empresaId: this.contratoId, filter: { chave } })

        return cte[format]['token']
    }

    async loadCtes(page = {}) {
        const filter = angular.copy(this.filter)

        let { contrato: { ctesPage: { after, before, ctes } } } =
            await this.listCtes({ empresaId: this.contratoId, order: this.order, filter, ...page })

        this.apply(() => {
            this.ctes = ctes
            this.nextPage = after
            this.previousPage = before
            this.currentPage = page.after ? this.currentPage + 1 : page.before ? this.currentPage - 1 : 1

            if (!page.after && !page.before)
                this.searchContext = new Date()
        })
    }

    async listCtes(variables) {
        const query = gql`
            query Ctes($empresaId: Int!, $order: CteOrder!, $filter: CteFilter!, $after: String, $before: String) {
                contrato: empresa(id: $empresaId) {
                    id
                    ctesPage(order: $order, filter: $filter, after: $after, before: $before, limit: ${this.perPage}) {
                        after
                        before
                        ctes: entries {
                            ... on Cte {
                                id
                                numero
                                chave
                                status
                                emissao
                                emissaoMunicipio
                                emissaoUf
                                origemMunicipio
                                origemUf
                                destinoMunicipio
                                destinoUf
                                valor
                                nfes{
                                    chave
                                    frete {
                                        freteCte {
                                            hasRateioFrete
                                            valorBaseCalculo
                                            valorIcms
                                        }
                                    }
                                }
                                emitente { ... ParticipanteFields }
                                remetente { ... ParticipanteFields }
                                destinatario { ... ParticipanteFields }
                                tomador { ... ParticipanteFields }
                            }
                        }
                    }
                }
            }
            
            fragment ParticipanteFields on CteParticipante {
                id
                razaoSocial
                cpfCnpj
                cidade
                uf
            }
        `

        return await this.gql.query(query, variables)
    }
}

angular.module('eficienciaFiscalModule')
    .component('cteList', {
        controller: CteList,
        bindings: {
            filter: '<',
            contratoId: '<'
        },
        //language=HTML
        template: () => {
            const downloadOptions = () => {
                const createButton = (name, click) => {
                    return `
                        <button ng-hide="downloading" class="btn btn-xs btn-link" ng-click="${click}">
                            ${name}
                        </button>
                    `
                }

                return `
                    <promise-tracker promise="$ctrl.downloadPromise" active="downloading">
                        <div style="display: flex; align-items: center; justify-content: flex-end; margin: 0 0 9px;">
                            <span>Realizar o download dos resultados da consulta como:</span>
                            <div style="display: flex; text-decoration: underline; color: #3276b1;">
                                ${createButton("XLSX", "$ctrl.downloadXlsx()")}
                                ${createButton("ZIP dos XMLs", "$ctrl.downloadXmlZip()")}
                                ${createButton("ZIP dos DACTEs", "$ctrl.downloadDaZip()")}
                                <button ng-show="downloading" disabled class="btn btn-xs btn-link">
                                    <i class="fa fa-circle-o-notch fa-spin"></i> Baixando...
                                </button>
                            </div>
                        </div>
                    </promise-tracker>
                `
            }

            const dadosParticipante = (participante) => {
                return `
                    {{ cte.${participante}.razaoSocial }} <br/>
                    <i>
                        <small>
                            {{ cte.${participante}.cpfCnpj | cpfCnpj }} - {{ cte.${participante}.cidade }}/{{ cte.${participante}.uf }}
                        </small>
                    </i>
                `
            }

            return `
                <loading promise="$ctrl.loadingPromise">
                    <highlighted ng-show="$ctrl.ctes.length == 0">
                        <main>Nenhuma informação encontrada.</main>
                    </highlighted>
                    <highlighted ng-show="$ctrl.ctes == undefined">
                        <main>Preencha o filtro acima para realizar uma consulta.</main>
                    </highlighted>
                    <div ng-show="$ctrl.ctes.length > 0">
                        ${downloadOptions()}
                        <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                            current-page="$ctrl.currentPage" current-page-size="$ctrl.ctes.length" 
                            on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                        </cursor-paginator>
                        <script type="text/ng-template" id="popover-chave">
                            <div class="input-group">
                                <input type="text" class="form-control" style="background-color: white; cursor: text" readonly
                                        value="{{$context.chave}}">
                                <span class="input-group-btn">
                                    <button class="btn btn-default" type="button" title="Copiar" data-toggle="tooltip" 
                                            ng-click-copy="{{$context.chave}}">
                                        <i class="fa fa-copy"></i>
                                    </button>
                                </span>
                            </div>
                        </script>
                        <table class="table no-margin">
                            <thead>
                            <tr>
                                <th class="text-center" width="1">#</th>
                                <th ng-click="$ctrl.sortBy('NUMERO')" class="cursor-pointer">
                                    Número <i ng-class="$ctrl.getSortingClass('NUMERO')" class="fa"></i>
                                </th>
                                <th ng-click="$ctrl.sortBy('EMISSAO')" class="cursor-pointer">
                                    Emissão <i ng-class="$ctrl.getSortingClass('EMISSAO')" class="fa"></i>
                                </th>
                                <th colspan="4">Participantes</th>
                                <th ng-click="$ctrl.sortBy('VALOR')" class="cursor-pointer text-right">
                                    Valor <i ng-class="$ctrl.getSortingClass('VALOR')" class="fa"></i>
                                </th>
                                <th>Opções</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr ng-repeat-start="cte in $ctrl.ctes" ng-class-even="'tr-even'">
                                <td rowspan="2" class="text-center-middle">
                                    {{ $index + 1 + (($ctrl.currentPage - 1) * $ctrl.perPage) }}
                                </td>
                                <td rowspan="2" class="text-middle">
                                    {{ cte.numero }} <br/>
                                    <small>
                                        <b>Origem</b> <br/>
                                        <i class="no-break">{{ cte.origemMunicipio }}/{{ cte.origemUf }}</i>
                                    </small>
                                    <br/>
                                    <small>
                                        <b>Destino</b> <br/>
                                        <i class="no-break">{{ cte.destinoMunicipio }}/{{ cte.destinoUf }}</i>
                                    </small>
                                </td>
                                <td rowspan="2" class="text-middle">
                                    <span class="no-break">{{ cte.emissao | date:'short' }}</span> <br/>
                                    <small><i>{{ cte.emissaoMunicipio }}/{{ cte.emissaoUf }}</i></small>
                                    <br/>
                                    <i class="popover-auto popover-md">
                                        <a 
                                            href="javascript:void(0)" 
                                            popover-template="popover-chave" 
                                            popover-context="{chave: cte.chave, id: cte.id}">
                                            Ver chave
                                        </a>
                                    </i> 
                                    <br/>
                                    <span  ng-if="cte.status == 'Autorizado o uso do CT-e'">
                                        <i class="fa fa-check text-success" tooltip="Autorizado o uso do CT-e"></i> Autorizado
                                    </span>
                                    <span ng-if="cte.status == 'CT-e cancelado'">
                                        <i class="fa fa-times text-danger" tooltip="CT-e cancelado"></i> Cancelado
                                    </span>
                                </td>
                                <td class="text-middle text-right" width="1"><b>Emitente</b></td>
                                <td class="text-middle">${dadosParticipante("emitente")}</td>
                                <td class="text-middle text-right" width="1"><b>Remetente</b></td>
                                <td class="text-middle">${dadosParticipante("remetente")}</td>
                                <td rowspan="2" class="text-middle text-right no-break">{{ cte.valor | currency }}</td>
                                <td rowspan="2" class="text-middle no-break">
                                    <a href="javascript:void(0)" ng-click="$ctrl.downloadDa(cte)">DACTE</a> <br/>
                                    <a href="javascript:void(0)" ng-click="$ctrl.downloadXml(cte)">XML</a><br/>
                                    <a href="javascript:void(0)" ng-if="cte.nfes.length > 1" ng-click="$ctrl.rateioFrete(cte)">Rateio</a>
                                    <br/>
                                </td>
                            </tr>
                            <tr ng-repeat-end ng-class-even="'tr-even'">
                                <td class="text-middle text-right" width="1"><b>Destinatário</b></td>
                                <td class="text-middle">${dadosParticipante("destinatario")}</td>
                                <td class="text-middle text-right" width="1"><b>Tomador</b></td>
                                <td class="text-middle">${dadosParticipante("tomador")}</td>
                            </tr>
                            </tbody>
                        </table>
                        <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                            current-page="$ctrl.currentPage" current-page-size="$ctrl.ctes.length" 
                            on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                        </cursor-paginator>
                        ${downloadOptions()}
                    </div>
                </loading>
            `
        }
    })
